import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b93e2902"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown-menu" }
const _hoisted_2 = {
  key: 0,
  class: "items"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_fa_icon, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = !_ctx.show)),
      icon: "bars",
      color: "#3dc958",
      size: "2x",
      class: "menu-icon"
    }),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.gameKind === 'PRACTICE')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.show = false; _ctx.onNewGame();}),
                class: "item"
              }, "New Game"))
            : _createCommentVNode("", true),
          (_ctx.gameKind !== 'PRACTICE')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.show = false; _ctx.onLeaveGame();}),
                class: "item"
              }, "Leave Game"))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.onExitRoom();}),
            class: "item"
          }, "Exit Room"),
          _createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.logout();}),
            class: "item"
          }, "Logout"),
          _hoisted_3,
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.openDonate(); _ctx.show = false;}),
            class: "item"
          }, "Donate"),
          _createElementVNode("div", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.openHelp(); _ctx.show = false;}),
            class: "item"
          }, "Help"),
          _createElementVNode("div", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.openSettings(); _ctx.show = false;}),
            class: "item"
          }, "Settings")
        ]))
      : _createCommentVNode("", true)
  ]))
}